import React from "react";
import styles from "./blogs.module.css";

const Blogs = () => {
    const blogs = [
        {
            id: 1,
            title: "Milestone in Kidney Care with 200 Successful Dialysis Sessions",
            description: "A major step forward in kidney health has been achieved with 200 successful dialysis treatments, highlighting the importance of advanced care and patient support.",

            image: "https://apolloclinicguwahati.co.in/assets/health-packages/9c2fb151595e723e26de1b5effa44df0b63f67715d5dfcb75e9df8d6e84070a1_Whole%20Body%20Check.png",
        },
        {
            id: 2,
            title: "AI in Healthcare Revolution",
            description: "Artificial Intelligence is transforming the healthcare sector with faster diagnoses and personalized treatment plans.",
            image: "https://apolloclinicguwahati.co.in/assets/health-packages/26b941fd91d3b663783a84f80102b36218958703d41ecb30c8fa554cd02f842e_Executive%20Health%20Check.png",
        },
        {
            id: 3,
            title: "Future of Telemedicine",
            description: "Telemedicine is bridging gaps between doctors and patients, ensuring healthcare is accessible anytime, anywhere.",
            image: "https://apolloclinicguwahati.co.in/assets/health-packages/762fbcb965cf0b0da1d2697926e9f1a78432df95e37ad8d9e86124c2cf7db6f2_Comprehensive%20Health%20Check.png",
        },
    ];

    return (
        <section className={styles.blogsSection}>
            <div className={styles.header}>
                <h2 className={styles.mainHeadingTitle}>Latest Blogs</h2>
                <button className={styles.viewAllBtn}>View All Blogs</button>
            </div>

            <div className={styles.blogGrid}>
                {blogs.map((blog) => (
                    <div key={blog.id} className={styles.blogCard}>
                        <img src={blog.image} alt={blog.title} className={styles.blogImage} />
                        <div className={styles.blogContent}>
                            <h3 className={styles.blogTitle}>{blog.title}</h3>
                            <p className={styles.blogDesc}>{blog.description}</p>
                            <button className={styles.readMoreBtn}>Read More</button>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Blogs;
